var React = require('react');

function SocialInstagram (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"Instagram"),React.createElement("g",{"data-name":"Layer 2","key":2},React.createElement("g",{"data-name":"Layer 1"},React.createElement("path",{"d":"M20.5,0H4.9A4.91,4.91,0,0,0,0,4.9V20.5a4.91,4.91,0,0,0,4.9,4.9H20.5a4.91,4.91,0,0,0,4.9-4.9V4.9A4.91,4.91,0,0,0,20.5,0Zm1.4,3h.6V7.4H18.2V3.1ZM9,10.1a4.49,4.49,0,0,1,3.6-1.9,4.24,4.24,0,0,1,3.6,1.9,4.48,4.48,0,1,1-8.1,2.6A6.22,6.22,0,0,1,9,10.1ZM22.9,20.6A2.43,2.43,0,0,1,20.5,23H4.9a2.43,2.43,0,0,1-2.4-2.4V10.1H6.3a7.51,7.51,0,0,0-.5,2.6,7,7,0,0,0,14,0h0a7.51,7.51,0,0,0-.5-2.6h3.8V20.6Z"})))]);
}

SocialInstagram.defaultProps = {"viewBox":"0 0 25.4 25.4"};

module.exports = SocialInstagram;

SocialInstagram.default = SocialInstagram;
